import {init} from "./entry"
import {report_error} from "@cling/lib.shared.debug"
import {start_public_board} from "./startup/startup_public_board"

if (process.env.NODE_ENV !== "test") {
    init()
    start_public_board().catch(report_error)
}
